import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { ILookupModel } from '../../interfaces/ILookup';

interface IProps {
    selectedRoleRights: ILookupModel[];
}

export const SelectedRoleRights = ({ selectedRoleRights }: IProps) => {
    const sortedRoleRights = selectedRoleRights.sort((a: ILookupModel, b: ILookupModel) =>
        a.displayName && a.displayName !== null && b.displayName && b.displayName !== null
            ? a.displayName < b.displayName
                ? -1
                : 1
            : 1
    );

    return (
        <>
            {sortedRoleRights.map((lu: ILookupModel) => {
                const renderTooltip = (props: any) => (
                    <Tooltip id="button-tooltip" {...props}>
                        <div style={{ textAlign: 'left' }}>{lu.description}</div>
                    </Tooltip>
                );

                return (
                    <div className="row mb-2">
                        {lu.description !== null ? (
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip}
                            >
                                <div>{lu.displayName}</div>
                            </OverlayTrigger>
                        ) : (
                            <div>{lu.displayName}</div>
                        )}
                    </div>
                );
            })}
        </>
    );
};
